import { useMemo } from 'react';
import ReactQuill from 'react-quill';
import styled from 'styled-components';

import { units } from '../../helpers/styles/units';

import 'react-quill/dist/quill.snow.css';

const EDITOR_MODULES = {
    toolbar: [['bold', 'italic']],
};

const EDITOR_FORMATS = ['bold', 'italic'];

const StyledEditorWrapper = styled.div`
  width: 100%;

  & .ql-toolbar.ql-snow {
    border: 1px solid #d7d7d7;
    border-bottom: none;
    padding: ${units(4)};
  }

  & .ql-container.ql-snow {
    border: 1px solid #d7d7d7;
    min-height: ${units(120)};

    & .ql-editor {
      min-height: ${units(120)};
      padding: ${units(8)};
    }
  }
`;

type FaqAnswerEditorProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
};

export const isFaqAnswerEmpty = (value: string) => {
    const plainText = value
        .replace(/<(.|\n)*?>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim();

    return !plainText;
};

export const FaqAnswerEditor = ({
    value,
    onChange,
    placeholder = 'Ответ',
}: FaqAnswerEditorProps) => {
    const modules = useMemo(() => EDITOR_MODULES, []);

    return (
        <StyledEditorWrapper>
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={EDITOR_FORMATS}
                placeholder={placeholder}
            />
        </StyledEditorWrapper>
    );
};
